/**
 * One staff member's permissions (الصلاحيات), opened from their row in the
 * Users list: the shared grid (components/PermissionsGrid), read from and
 * saved to the server. The same grid sits inside the Add / Edit User form.
 */

import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";

import CargoLoader from "components/CargoLoader";
import PermissionsGrid, { toggle } from "components/PermissionsGrid";
import DialogShell from "layouts/accounting/DialogShell";

export { toggle };

const API = "https://trust-cargo.co/anas_backend/api/v2/users";

const headers = () => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
});

const problemOf = (e, fallback) =>
  e?.response?.status === 401
    ? "انتهت جلسة الدخول. سجّل خروج وادخل من جديد."
    : e?.response?.data?.message || fallback;

function PermissionsDialog({ user, onClose }) {
  const [catalog, setCatalog] = useState([]);
  const [picked, setPicked] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    setError("");
    axios
      .get(`${API}/${user.id}/permissions`, { headers: headers() })
      .then((r) => {
        setCatalog(r.data?.catalog || []);
        setPicked(r.data?.permissions || []);
      })
      .catch((e) => setError(problemOf(e, "Could not load the permissions")))
      .finally(() => setLoading(false));
  }, [user]);

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      await axios.put(
        `${API}/${user.id}/permissions`,
        { permissions: picked },
        { headers: headers() }
      );
      setSaving(false);
      onClose();
    } catch (e) {
      setSaving(false);
      setError(problemOf(e, "Could not save the permissions"));
    }
  };

  return (
    <DialogShell
      open={Boolean(user)}
      title={`الصلاحيات · Permissions - ${user?.name || ""}`}
      onClose={onClose}
      onSave={loading ? null : save}
      saving={saving}
      error={error}
      maxWidth="lg"
    >
      {loading ? (
        <CargoLoader />
      ) : (
        <PermissionsGrid catalog={catalog} value={picked} onChange={setPicked} />
      )}
    </DialogShell>
  );
}

PermissionsDialog.defaultProps = { user: null };

PermissionsDialog.propTypes = {
  user: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }),
  onClose: PropTypes.func.isRequired,
};

export default PermissionsDialog;
